import React from 'react'
import xss from 'xss'
import './resource-card.css'

export type ResourceCardProps = {
  url: string
  title: string
  className?: string
  subtopics: string[]
  subtopicdetails: string[]
  description: string
  imageUrl: string
  readTime: string
  testId?: string
}

export const ResourceCard = ({
  url,
  title,
  className,
  subtopics,
  subtopicdetails,
  description,
  imageUrl,
  readTime,
  testId
}: ResourceCardProps) => {
  const stripMarkdownFormatting = (str: string) => {
    if (!str) return ''
    const newStr = str.replace(/\*/gi, '').replace(/\^/gi, '')
    return newStr.replace(' | Ameriprise Financial', '').trim()
  }

  const formatTopics = (topics: string[]) => {
    if (topics.length === 0) return ''
    return topics.map(topic => topic.replace(/-/gi, ' ')).join(' | ')
  }

  return (
    <div className={`ResourceCard Card ${className ?? ''}`}>
      <a href={url} className={`Link--stretched`}>
        <span
          className="u-hidden"
          dangerouslySetInnerHTML={{
            __html: xss(stripMarkdownFormatting(title))
          }}
        />
      </a>
      <div
        className="ResourceCard-image u-bgSizeCover"
        data-testid={testId ? `${testId}-card-image` : null}
        style={{
          backgroundImage: `url(${imageUrl})`
        }}
      ></div>
      <div className="Content Card-content u-padding20">
        <p className="Card-superHeading u-textSizeMsrm1">
          {subtopicdetails.length !== 0 ? (
            <span
              className={'subtopic u-marginRight4'}
              data-testid={testId ? `${testId}-subtopicdetail` : null}
            >
              {formatTopics(subtopicdetails)}
            </span>
          ) : (
            <span
              className={'subtopic u-marginRight4'}
              data-testid={testId ? `${testId}-subtopic` : null}
            >
              {formatTopics(subtopics)}
            </span>
          )}
        </p>
        <h3
          className="Card-heading u-textSizeMsrp2 u-marginVert4"
          style={{ WebkitBoxOrient: 'vertical' }}
          dangerouslySetInnerHTML={{
            __html: xss(stripMarkdownFormatting(title))
          }}
          data-testid={testId ? `${testId}-title` : null}
        ></h3>
        <div
          className="Card-description u-textSizeMsr u-marginVert20"
          data-testid={testId ? `${testId}-description` : null}
        >
          <p style={{ WebkitBoxOrient: 'vertical' }}>{description}</p>
        </div>
        <div className="ResourceCard-readTime u-textSizeMsrm1">
          <p>{readTime}</p>
        </div>
      </div>
    </div>
  )
}
